import { format } from 'date-fns';

export const getTimeInputFromTimestamp = (timeStamp) => {
  if (!timeStamp) return '';
  const timeInput = format(new Date(timeStamp), 'HH:mm');

  return timeInput;
};
